import React, { useState } from 'react'
import BossDialog from '../../components/BossDialog'
import { useTranslation } from '../../locale/useTranslation'
import { EditPageHeader } from '../../components/EditPageHeader';
import { ENTITYNAME, TOAST_TYPES } from '../../framework/constant/constant';
import * as API from "../../framework/API/api";
import ToastNotification from '../../components/ToastNotification';

const MediaEpisodeSettingForm = (props) => {

    const { onCancel, entityName, data, setData } = props;
    const lang = useTranslation();
    const blankDataItem = {
        ...data,
        Colors: {
            Foreground: data.Settings?.Colors?.Foreground ?? "",
            Background: data.Settings?.Colors?.Background ?? ""
        },
        RouterCommand: data.Settings?.RouterCommand ?? "",
        HardDisk: data.Settings?.HardDisk ?? ""
    }
    const [dataItem, setDataItem] = useState(blankDataItem);

    const onChange = async (e) => {
        if (e.target.name == "Foreground" || e.target.name == "Background") {
            setDataItem({ ...dataItem, Colors: { ...dataItem.Colors, [e.target.name]: e.target.value } });
        } else {
            setDataItem({ ...dataItem, [e.target.name]: e.target.value });
        }
    };

    const onSyncSeasonColorsWithEps = async () => {
        let dataRes = await API.syncSeasonConfigInEpisodes({
            Season_id: data?._id,
            ["Settings.Colors"]: dataItem?.Colors ? dataItem?.Colors : null
        });

        if (dataRes.success) {
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: dataRes.message });
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: dataRes.message });
        }

    }

    const onSyncRouterCommandWithEps = async () => {

        let dataRes = await API.syncSeasonConfigInEpisodes({
            Season_id: data?._id,
            ["Settings.RouterCommand"]: dataItem?.RouterCommand ?? ""
        });
        if (dataRes.success) {
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: dataRes.message });
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: dataRes.message });
        }
    }

    const handleSubmit = async () => {
        const finalData = {
            _id: data?._id,
            SID: data?.SID,
            Settings: {
                Colors: {
                    Foreground: dataItem?.Colors?.Foreground ?? "",
                    Background: dataItem?.Colors?.Background ?? ""
                },
                RouterCommand: dataItem?.RouterCommand ?? "",
                HardDisk: dataItem?.HardDisk ?? "",
            }
        }
        console.log(finalData)
        const res = await API.saveData(entityName, finalData)
        if (res.success) {
            if (setData) setData({ ...data, Settings: finalData?.Settings })
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.settings_updated_successfully_message });
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
        onCancel();
    }

    const style = {
        sectionTitle: { marginBottom: '16px', padding: '12px 14px', background: '#fafafa', borderRadius: '6px', border: '1px solid #f0f0f0' },
        labelStyle: { fontSize: '11px', fontWeight: 600, color: '#444', marginBottom: '3px', display: 'block' }
    }

    return (
        <>
            <BossDialog title={lang.setting_header} onClose={onCancel} width={"48%"}>
                <EditPageHeader onSubmit={handleSubmit} onCancel={onCancel} showTitle={false} />
                <div style={{ padding: '16px 8px 8px 8px' }}>
                    {/* Section 1: Color Configuration */}
                    <div style={{ ...style.sectionTitle, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <i className="fa-solid fa-palette" style={{ color: '#1a73e8', fontSize: '14px' }}></i>
                            <span style={{ fontSize: '12px', fontWeight: 600, color: '#333', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                {lang.color_settings ?? 'Color Configuration'}
                            </span>
                        </div>
                        {entityName === ENTITYNAME.Season && (
                            <button
                                type="button"
                                style={{ height: "28px", display: 'flex', alignItems: 'center', gap: '6px', padding: '0 10px', fontSize: '11px' }}
                                title='Sync Color With Episodes'
                                className="k-button k-button-sm k-rounded-md k-button-solid k-button-solid-primary"
                                onClick={onSyncSeasonColorsWithEps}
                            >
                                <i className="fa-solid fa-arrows-rotate"></i>
                            </button>
                        )}
                    </div>

                    <div style={{ display: 'flex', gap: '20px', marginBottom: '24px', padding: '0 4px', alignItems: 'flex-end' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', flex: 1, gap: '4px' }}>
                            <label style={style.labelStyle} htmlFor="Foreground">
                                {lang.foreground_Color_label}
                            </label>
                            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                                <input
                                    type="text"
                                    id="Foreground"
                                    className="form-control form-control-sm"
                                    name="Foreground"
                                    value={dataItem?.Colors?.Foreground}
                                    onChange={onChange}
                                    style={{ flex: 1, height: '32px', borderRadius: '4px' }}
                                />
                                <input
                                    type="color"
                                    name="Foreground"
                                    value={dataItem?.Colors?.Foreground}
                                    onChange={onChange}
                                    title={lang.text_color_label}
                                    style={{
                                        width: '34px',
                                        height: '32px',
                                        padding: '2px',
                                        border: '1px solid #ced4da',
                                        borderRadius: '4px',
                                        cursor: 'pointer',
                                        backgroundColor: 'transparent'
                                    }}
                                />
                            </div>
                        </div>

                        <div style={{ display: 'flex', flexDirection: 'column', flex: 1, gap: '4px' }}>
                            <label style={style.labelStyle} htmlFor="Background">
                                {lang.background_color_label}
                            </label>
                            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                                <input
                                    type="text"
                                    id="Background"
                                    className="form-control form-control-sm"
                                    name="Background"
                                    value={dataItem?.Colors?.Background}
                                    onChange={onChange}
                                    style={{ flex: 1, height: '32px', borderRadius: '4px' }}
                                />
                                <input
                                    type="color"
                                    name="Background"
                                    value={dataItem?.Colors?.Background}
                                    onChange={onChange}
                                    title={lang.text_color_label}
                                    style={{
                                        width: '34px',
                                        height: '32px',
                                        padding: '2px',
                                        border: '1px solid #ced4da',
                                        borderRadius: '4px',
                                        cursor: 'pointer',
                                        backgroundColor: 'transparent'
                                    }}
                                />
                            </div>
                        </div>

                        <div style={{ display: 'flex', flexDirection: 'column', width: '120px', gap: '4px' }}>
                            <label style={style.labelStyle}>{lang.preview_label ?? 'Preview'}</label>
                            <div style={{
                                height: '32px',
                                borderRadius: '4px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                border: '1px solid #ced4da',
                                backgroundColor: dataItem?.Colors?.Background || '#ffffff',
                                color: dataItem?.Colors?.Foreground || '#000000',
                                fontWeight: '600',
                                fontSize: '11px',
                                boxShadow: 'inset 0 1px 3px rgba(0,0,0,0.05)',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                padding: '0 8px',
                                transition: 'all 0.2s ease-in-out'
                            }}>
                                Text
                            </div>
                        </div>
                    </div>

                    {/* Section 2: System Settings */}
                    <div style={{ ...style.sectionTitle, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <i className="fa-solid fa-sliders" style={{ color: '#28a745', fontSize: '14px' }}></i>
                            <span style={{ fontSize: '12px', fontWeight: 600, color: '#333', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                {lang.system_settings ?? 'System Settings'}
                            </span>
                        </div>
                    </div>

                    <div style={{ display: 'flex', gap: '20px', padding: '0 4px' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', flex: 1, gap: '4px' }}>
                            <label style={style.labelStyle} htmlFor="RouterCommand">
                                {lang.router_command_label}
                            </label>
                            <input
                                type="text"
                                id="RouterCommand"
                                className="form-control form-control-sm"
                                name="RouterCommand"
                                value={dataItem?.RouterCommand}
                                onChange={onChange}
                                style={{ height: '32px', borderRadius: '4px' }}
                            />
                        </div>

                        {entityName === ENTITYNAME.Season && (
                            <button
                                type="button"
                                style={{ height: "28px", display: 'flex', alignItems: 'center', gap: '6px', padding: '0 10px', fontSize: '11px', marginTop: '25px' }}
                                title='Sync Router Command With Episodes'
                                className="k-button k-button-sm k-rounded-md k-button-solid k-button-solid-primary"
                                onClick={onSyncRouterCommandWithEps}
                            >
                                <i className="fa-solid fa-arrows-rotate"></i>
                            </button>
                        )}

                        <div style={{ display: 'flex', flexDirection: 'column', flex: 1, gap: '4px' }}>
                            <label style={style.labelStyle} htmlFor="HardDisk">
                                {lang.hard_disk_label}
                            </label>
                            <input
                                name="HardDisk"
                                type="text"
                                id="HardDisk"
                                className="form-control form-control-sm"
                                value={dataItem?.HardDisk}
                                onChange={onChange}
                                style={{ height: '32px', borderRadius: '4px' }}
                            />
                        </div>
                    </div>
                </div>
            </BossDialog>
        </>
    )
}

export default MediaEpisodeSettingForm